var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.persistentNavRoutes !== null)?_c('div',{staticClass:"pb50-sm"},[_c('ul',[_c('CommonBaseNavBarRoutes',{attrs:{"routes":_vm.persistentNavRoutes}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }